/***************************************************************
10/5/2017
Alexander Self
Dashboard Chart Card
***************************************************************/
import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  canvasId: PropTypes.string,
  label: PropTypes.string
};

const DashboardCard = ({ canvasId, label }) => {
  return (
    <div className="card">
      <div className="card-content">
        <span className="weather-card-title grey-text text-darken-4">{label}</span>
        <canvas id={canvasId} className="weather-chart"></canvas>
      </div>
    </div>
  );
};

DashboardCard.propTypes = propTypes;
export default DashboardCard;



// WEBPACK FOOTER //
// ./src/weather/components/dashboard_card.js